import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiasEnCargaZE, PendientesCargaZE, ResumenCargaZE } from "./items";

export interface Props {
    /**idCargaDescarga */
    value: number;
}
/**Toma el IdCargaDescarga y muestra su status */
export class EstatusCargaDescarga extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <kea.Tab
                    items={[
                        {
                            title: "Resumen",
                            iconClass: fa("list-ol"),
                            body: <ResumenCargaZE value={this.props.value} />,
                            quitar: false
                        },
                        {
                            title: "Paquetes/sobres de guias incompletas",
                            iconClass: fa("cubes"),
                            body: <PendientesCargaZE idCargaZE={this.props.value} />,
                            quitar: true
                        },
                        {
                            title: "Guias incluidas",
                            iconClass: fa("files-o"),
                            body: <GuiasEnCargaZE idCargaZE={this.props.value} />,
                            quitar: true
                        }
                    ]}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasze/edit/status/index.tsx